import httpService from "./httpService";
import utils from "./utils";

export default {
  findAll(form, pageable) {
    let params = utils.merge(form, pageable);
    return httpService.get("/hcCaseDieuXeView", {params: params});
  }
};



// WEBPACK FOOTER //
// ./src/services/hcCaseDieuXeViewService.js